import { has } from "../../../../utils/menu-context";
import store from "../../../../store";
import { commonComponentProp, commonInputPropField } from "../../inform/request/request.condition";

export const createConditionAction = () => {
    return {
        canEdit: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) return false;
            if (record.createBy === store.state.resource.auth.info.user?.username
                // || (record.createBy === "anonymousUser" && record.refManufactureSampleTemp?.refUser?.username === store.state.resource.auth.info.user?.username)
                || (record.refManufactureSampleTemp?.refUser?.username === store.state.resource.auth.info.user?.username)
            ) {
                if ([undefined, "draft", "reEditOfficer", "reEditAuthority"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forReceive" })) {
                if (["waitReceive"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forApprove" })) {
                if (["waitApprove"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canArchive: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canArchive" }) || record.isActive === false) return false;
            if (["draft"].includes(record.refStatus?.key)) {
                result = true || result;
            }
            return result;
        },
        canDelete: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canDelete" }) || record.isActive === false) return false;
            if (["draft"].includes(record.refStatus?.key)) {
                result = true || result;
            }
            return result;
        },
        canWaitReceive: ({ record }) => {
            let result = false;
            if (
                (record.createBy === store.state.resource.auth.info.user?.username ||
                    (record.createBy === "anonymousUser" &&
                        record.refManufactureSampleTemp?.refUser?.username === store.state.resource.auth.info.user?.username)) &&
                !record.isOfficerCreate
            ) {
                if ([undefined, "draft", "reEditOfficer", "reEditAuthority"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canWaitApprove: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (has({ menuContext, key: "forReceive" })) {
                if (["waitReceive"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (record.isOfficerCreate) {
                if (["draft", "reEditOfficer", "reEditAuthority"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canApprove: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            const userInfo = store.state.resource.auth.info?.user;
            if (has({ menuContext, key: "forApprove" })) {
                if (["waitApprove"].includes(record.refStatus?.key)) {
                    if (record.refToApproveBy?.username === userInfo.username) {
                        result = true || result;
                    }
                }
            }
            return result;
        },
        canCancel: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (has({ menuContext, key: "forRequest" })) {
                if (["draft", "reEditOfficer", "reEditAuthority"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forReceive" })) {
                if (["waitReceive"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forApprove" })) {
                if (["waitApprove"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canReStatus: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (has({ menuContext, key: "forRequest" })) {
                if (["waitReceive"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forReceive" })) {
                if (["waitApprove"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canReport: ({ record }) => {
            return !["draft"].includes(record.refStatus?.key);
        }
    };
};

export const createConditionForm = () => {
    return [
        {
            check: ({ field }) => {
                return [
                    "refDepartment.nameEn",
                    "lastStatus.waitReceive.0.statusDatetime",
                    "lastStatus.draft.0.statusDatetime",
                    "lastStatus.waitApprove.0.statusDatetime",
                    "refManufactureSampleTemp.refUserCompany.companyNameEn",
                    "refManufactureSampleTemp.refUser.fullNameEn",
                    "refManufactureSampleTemp.refUserCompany.addresses.0.addrTh",
                    "refManufactureSampleTemp.refUser.addresses.0.addrTh"
                ].includes(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return ["refManufactureSampleTemp.refUserCompany.idCard"].includes(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return ["refManufactureSampleTemp.refUser.idCard"].includes(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return ["refRequestType"].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitReceive",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: []
            })
        },
        {
            check: ({ field }) => {
                return ["refDocGenType", "requestCode"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.isOfficerCreate;
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitReceive",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return ["refManufactureSampleTemp.approveCode"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.isOfficerCreate;
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitReceive",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["2", "3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return ["refManufactureSampleTemp.refUserCompany", "refDepartment"].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitReceive",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["2", "3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return ["refManufactureSampleTemp.refUser"].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return ["refManufactureSample"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return ["2", "3", "4"].includes(modelRef.refRequestType?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitReceive",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: []
            })
        },
        {
            check: ({ field }) => {
                return ["refManufactureSampleTemp.refOperation"].includes(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return ["lastStatus.forRequestRemark.0.remark"].includes(field?.key);
            },
            inputPropField: ({ modelRef, initialModel }) => {
                const common = commonInputPropField({
                    disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: []
                })({ modelRef, initialModel });
                if (modelRef.isOfficerCreate) {
                    return { ...common, disabled: true };
                }
                return common;
            }
        },
        {
            check: ({ field }) => {
                return ["lastStatus.forReceiveRemark.0.remark"].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    undefined,
                    "draft",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: []
            })
        },
        {
            check: ({ field }) => {
                return [
                    "refManufactureSampleTemp.refHazObject",
                    "refManufactureSampleTemp.dangerousTh",
                    "refManufactureSampleTemp.officialNameTh",
                    "refManufactureSampleTemp.officialNameEn",
                    "refManufactureSampleTemp.manufacturer",
                    "refManufactureSampleTemp.refCategoryStatus",
                    "refManufactureSampleTemp.category",
                    "refManufactureSampleTemp.formula",
                    "refManufactureSampleTemp.productionAddressName",
                    "refManufactureSampleTemp.contactAddressName",
                    "refManufactureSampleTemp.quantity",
                    "refManufactureSampleTemp.refUnit",
                    "refManufactureSampleTemp.refPackage"
                ].includes(field?.key);
            },
            inputPropField: ({ props, modelRef, initialModel }) => {
                const { viewOnly, menuContext } = props;
                let enabled = false;
                if (has({ menuContext, key: "forRequest" })) {
                    if ([undefined, "draft", "reEditOfficer", "reEditAuthority"].includes(initialModel.refStatus?.key)) {
                        enabled = !viewOnly || enabled;
                    }
                }
                if (["3", "4"].includes(modelRef.refRequestType?.key)) {
                    enabled = false;
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return ["refManufactureSampleTemp.products"].includes(field?.key);
            },
            inputPropField: ({ props, modelRef, initialModel }) => {
                const { viewOnly, menuContext } = props;
                let enabled = false;
                if (has({ menuContext, key: "forRequest" })) {
                    if ([undefined, "draft", "reEditOfficer", "reEditAuthority"].includes(initialModel.refStatus?.key)) {
                        enabled = !viewOnly || enabled;
                    }
                }
                if (["3", "4"].includes(modelRef.refRequestType?.key)) {
                    enabled = false;
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return new RegExp(
                    `^refManufactureSampleTemp\\.addresses\\.[^\\.]+\\.(refAddressType|tel|fax|latitude|longitude|map)$`,
                    "g"
                ).test(field?.key);
            },
            visibleField: () => {
                return false;
            }
        },
        {
            check: ({ field }) => {
                return new RegExp(
                    `^refManufactureSampleTemp\\.addresses\\.[^\\.]+\\.(noTh|roomTh|buildingTh|floorTh|villageTh|mooTh|soiTh|roadTh|refProvince|postCode|refAmphur|refTambon)$`,
                    "g"
                ).test(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return new RegExp(
                    `^refManufactureSampleTemp\\.qties\\.[^\\.]+\\.(quantity|refUnit|refPackage)$`,
                    "g"
                ).test(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return new RegExp(
                    `^refManufactureSampleTemp\\.attachments\\.[^\\.]+\\.(documentName|(attribute\\.(documentNo|documentDate|documentExpiredDate))|size)$`,
                    "g"
                ).test(field?.key);
            },
            inputPropField: ({ modelRef, initialModel, record }) => {
                const common = commonInputPropField({
                    disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: []
                })({ modelRef, initialModel });
                if (common.disabled !== true) {
                    if (["3", "4"].includes(modelRef.refRequestType?.key)) {
                        if (record?.attribute?.isDisabledDocumentName) {
                            common.disabled = true;
                        }
                    }
                }
                return common;
            }
        },
        {
            check: ({ componentKey }) => {
                return new RegExp(`^ManufactureSampleQuantityTable$`, "g").test(componentKey);
            },
            inputPropField: commonComponentProp({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ componentKey }) => {
                return ["AttachmentInlineList"].includes(componentKey);
            },
            inputPropField: ({ props, initialModel }) => {
                const { viewOnly } = props;
                let canCreate = false;
                let canDelete = false;
                if ([undefined, "draft", "reEditOfficer", "reEditAuthority"].includes(initialModel.refStatus?.key)) {
                    canCreate = !viewOnly || canCreate;
                    canDelete = !viewOnly || canDelete;
                }
                return { canCreate, canDelete };
            }
        }
    ];
};

// const commonInputPropField = ({ props, modelRef, initialModel }) => {
//     const { viewOnly, menuContext } = props;
//     let enabled = undefined;
//     if (has({ menuContext, key: "forRequest" })) {
//         if ([undefined, "draft", "reEditOfficer", "reEditAuthority"].includes(initialModel.refStatus?.key)) {
//             enabled = !viewOnly || enabled;
//         }
//     }
//     if (has({ menuContext, key: "forReceive" })) {
//         enabled = false;
//     }
//     if (has({ menuContext, key: "forApprove" })) {
//         enabled = false;
//     }
//     if (["3", "4"].includes(modelRef.refRequestType?.key)) {
//         enabled = false;
//     }
//     return { disabled: enabled !== undefined ? !enabled : undefined };
// };
